import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import emailValidator from 'email-validator';
import { useForm } from 'react-hook-form'
import { Tooltip, } from 'react-tooltip'
import { useLocation, useParams } from 'react-router-dom'
import Loading from '../components/Loading'
import { projectContext, loadingContext, urlValue, unfolder, onImportExcelAsync, closeModalVw, openModalVw, openAlert, downloadFileNew, encrypter, useTranslate} from '../lib'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../components/common/ModalVw'
import { SelectNesting } from '../components/common/Inputs/Select'
import SideBar from '../components/SideBar'
import SideBarGenAI from '../components/ProjectGenAI/SideBarGenAI';
import TitleBar from "../components/TitleBar";
import CheckBox2 from '../components/CheckBox2'
import { Alerts } from '../components/common/Alerts'
import NewUserStudio from '../components/NewUserStudio'
import NewUserClient from '../components/NewUserClient'
import { SettingsOptions } from '../components/SettingsOptions'
import '../styles/settings.scss'
import '../styles/settingsOptions.scss'
import '../styles/styles.css'
import 'react-tooltip/dist/react-tooltip.css'
import ProjectAdministrators from '../components/ProjectAdministrators';
import DataTable from '../components/provider/datatable/Datatable';
// import { AuthenticationDetails, CognitoUser, CognitoUserPool, CognitoUserAttribute, } from 'amazon-cognito-identity-js';
const AmazonCognitoIdentity = require('amazon-cognito-identity-js');
const AWS = require('aws-sdk');

export default function Settings() {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [clients, setClients] = useState([])
  const [isModalOpen, setIsModalOpen] = useState({
    delete: false,
    new: false,
    edit: false,
    delete_many: false
  })
  const [isModalOpenTypeUser, setIsModalOpenTypeUser] = useState({
    delete: false,
    new: false,
    edit: false,
    delete_many: false
  })
  const [isModalOpenGuest, setIsModalOpenGuest] = useState({
    delete: false,
    new: false,
    edit: false,
    delete_many: false
  })
  const [isModalOpenUserStudio, setIsModalOpenUserStudio] = useState({
    delete: false,
    new: false,
    edit: false,
    delete_many: false
  })
  const [refresh, setRefresh] = useState(false)
  const [selectedClient, setSelectedClient] = useState()
  const [avatarPreviewEdit, setAvatarPreviewEdit] = useState(null)
  const [avatarFileEdit, setAvatarFileEdit] = useState(null)
  const [uploadingAvatarEdit, setUploadingAvatarEdit] = useState(false)
  const [avatarError, setAvatarError] = useState(false)
  const ref = useRef(null)
  const fetchAvatarRequestRef = useRef(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useContext(loadingContext)
  const [usersDelete, setUsersDelete] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [alert, setAlert] = useState({ title: '', visible: false })
  const [role, setRole] = useState(0)
  const [refreshAdmin, setRefreshAdmin] = useState(false);
  const location = useLocation();
  const isGenAI = location.pathname.includes('GenAI') || location.pathname.includes('UsersGenAI');
  const { t } = useTranslate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    if (!selectedProject || !selectedProject.id) {
      try {
        const saved = localStorage.getItem('lastSelectedProject');
        if (saved) {
          const proj = unfolder(saved, 'IANestingKey');
          if (proj?.id) setSelectedProject(proj);
        }
      } catch(e) { console.error(e) }
    }
  }, []);

  useEffect(() => {
    if (!selectedProject?.id) return;
    
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/client-project/${selectedProject.id}`,
      headers: {
        user: id,
        'access-token': token,
      },
    })
      .then(function (response) {
        setClients(response.data.clients)
        setLoading(false)
      })
      .catch(function (error) {
        setLoading(false)
      })
  }, [selectedProject?.id, refresh])

  useEffect(() => {
    const current = avatarPreviewEdit
    return () => {
      try {
        if (current && typeof current === 'string' && current.startsWith('blob:')) {
          URL.revokeObjectURL(current)
        }
      } catch (e) { /* ignore */ }
    }
  }, [avatarPreviewEdit])

  const fetchAvatarForEdit = async (clientId) => {
    try {

      const resp = await axios.get(`${urlValue}/studio/avatar`, {
        headers: {
          'access-token': unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token,
          'client-id': clientId,
          'folder': 'clients',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache'
        },
        responseType: 'blob',
        validateStatus: (status) => status >= 200 && status < 500,
      })

      if (resp && resp.status === 200 && resp.data && resp.data instanceof Blob) {
        const url = URL.createObjectURL(resp.data)
        return { type: 'blob', url }
      }

      if (resp && resp.data && typeof resp.data === 'object' && resp.data.url) {
        return { type: 'url', url: resp.data.url }
      }

      return null

    } catch (err) {
      console.warn('Avatar could not be loaded from server', err)
      return null
    }
  }

  function openModal(modal, client) {
    setValue('id', null)
    setValue('name', null)
    if (modal === 'new') {
      setIsModalOpen({ ...isModalOpen, new: true })
    } else {
      setSelectedClient(client)
      if (modal === 'edit') {
        // setIsModalOpen({ ...isModalOpen, edit: true })
        openModalVw("#edituser-md", () => setIsModalOpen({ ...isModalOpen, edit: true }))
        setValue('id', client.ccms_id)
        setValue('name', client.ccms_name)
        setValue('max_multichat', client.max_multichat)
        setValue('gender_avatar', client.gender_avatar)
        setValue('wave', client?.icims || '')

        try {
          if (avatarPreviewEdit && typeof avatarPreviewEdit === 'string' && avatarPreviewEdit.startsWith('blob:')) {
            URL.revokeObjectURL(avatarPreviewEdit)
          }
        } catch (e) { /* ignore */ }

        const immediatePreview = client?.avatar || client?.avatar_url || null
        setAvatarPreviewEdit(immediatePreview)
        setAvatarFileEdit(null)
        setAvatarError(false)

        ;(async () => {
          const clientId = client?.ccms_name
          fetchAvatarRequestRef.current = clientId
          let fetched = null
          try {
            fetched = await fetchAvatarForEdit(clientId)
          } catch (err) {
            console.warn('fetchAvatarForEdit failed', err)
          }
          if (fetchAvatarRequestRef.current === clientId) {
            if (fetched && fetched.url) {
              setAvatarPreviewEdit(fetched.url)
            } else {
              setAvatarPreviewEdit(null)
            }
            fetchAvatarRequestRef.current = null
          }
        })()
        console.log('client', client)
      } else {
        // setIsModalOpen({ ...isModalOpen, delete: true })
        openModalVw("#deleteuser-md", () => setIsModalOpen({ ...isModalOpen, delete: true }))
      }
    }
  }

  const onSubmitDelete = () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/client-project`,
      headers: {
        'access-token': token,
      },
    })
      .then(function (response) {
        const id = response.data.filter(value => {
          if (
            value.project_id === selectedProject.id &&
            value.client_id === selectedClient.id
          ) {
            return value
          }
        })[0].id
        axios({
          method: 'post',
          url: `${urlValue}/studio/client-project/${id}/delete`,
          headers: {
            'access-token': token,
            'X-CSRF-Token': csrfToken
          },
          withCredentials: true,
        })
          .then(function (response) {
            setLoading(false)
            setIsModalOpen({ ...isModalOpen, delete: false })
            setRefresh(!refresh)
          })
          .catch(function (error) {
            setLoading(false)
            setIsModalOpen({ ...isModalOpen, delete: false })
            setRefresh(!refresh)
          })
      })
      .catch(function (error) {
        setLoading(false)
        console.log(error)
      })
  }

  const onSubmitEdit = async data => {
    if (avatarError) {
      openAlert('#alert-ac', () => { 
        setAlert({ title: t('alerts.fixAvatarErrors'), visible: true, error: true }) 
      }, 4000, () => { setAlert({ ...alert, visible: false }) });
      return
    }
    
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    console.log("Ingresar")
    setLoading(true);
    axios({
      method: 'post',
      url: `${urlValue}/studio/client/${selectedClient.id}/update`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        ccms_id: data.id,
        ccms_name: data.name,
        max_multichat: data.max_multichat,
        gender_avatar: data.gender_avatar,
        icims: data.wave,
      },
    })
      .then(function (response) {
        console.log("Ok good")
        openAlert('#alert-ac', () => { setAlert({ title: t('alerts.accountChanged'), visible: true }) }, 4000,
          () => { setAlert({ ...alert, visible: false }) });
        console.log("Alert fin");
        setLoading(false);
        (async () => {
          try {
            if (avatarFileEdit && response?.data) {
              console.log('Uploading avatar after edit for client id:', selectedClient?.ccms_name);
              await uploadAvatarEdit(selectedClient?.ccms_name, avatarFileEdit)
            }
          } catch (err) {
            console.error('Avatar upload after edit failed');
          } finally {
            setIsModalOpen({ ...isModalOpen, edit: false })
            setRefresh(!refresh)
          }
        })()
      })
      .catch(function (error) {
        setLoading(false)
        setIsModalOpen({ ...isModalOpen, edit: false })
        const serverMessage = error?.response?.data?.message || error?.response?.data || error?.message || 'Error updating client'
        console.error('Edit client error', error);
        openAlert('#alert-ac', () => { setAlert({ title: serverMessage, visible: true, error: true }) }, 5000, () => { setAlert({ ...alert, visible: false }) });
      })
  }

  const handleAvatarEditChange = (e) => {
    const file = e.target.files[0]
    if (!file) {
      setAvatarError(false)
      return
    }
    
    const allowed = ['image/jpeg', 'image/png']
    if (!allowed.includes(file.type)) {
      setAvatarError(true)
      setAvatarPreviewEdit(null)
      setAvatarFileEdit(null)
      openAlert('#alert-ac', () => { setAlert({ title: t('alerts.avatarInvalidType'), visible: true, error: true }) }, 4000,
        () => { setAlert({ ...alert, visible: false }) });
      e.target.value = null
      return
    }
    if (file.size > 100 * 1024) {
      setAvatarError(true)
      setAvatarPreviewEdit(null)
      setAvatarFileEdit(null)
      openAlert('#alert-ac', () => { setAlert({ title: t('alerts.avatarTooLarge'), visible: true, error: true }) }, 4000,
        () => { setAlert({ ...alert, visible: false }) });
      e.target.value = null
      return
    }
    
    const img = new Image()
    const url = URL.createObjectURL(file)
    img.onload = () => {
      if (img.width > 200 || img.height > 200) {
        setAvatarError(true)
        setAvatarPreviewEdit(null)
        setAvatarFileEdit(null)
        openAlert('#alert-ac', () => { setAlert({ title: t('alerts.avatarDimensionsExceeded'), visible: true, error: true }) }, 4000,
          () => { setAlert({ ...alert, visible: false }) });
        URL.revokeObjectURL(url)
        e.target.value = null
        return
      }
      setAvatarError(false)
      setAvatarPreviewEdit(url)
      setAvatarFileEdit(file)
      openAlert('#alert-ac', () => { setAlert({ title: t('alerts.avatarLoadedSuccess'), visible: true }) }, 4000,
        () => { setAlert({ ...alert, visible: false }) });
    }
    img.onerror = () => {
      setAvatarError(true)
      setAvatarPreviewEdit(null)
      setAvatarFileEdit(null)
      openAlert('#alert-ac', () => { setAlert({ title: t('alerts.avatarLoadError'), visible: true, error: true }) }, 4000,
        () => { setAlert({ ...alert, visible: false }) });
      URL.revokeObjectURL(url)
      e.target.value = null
    }
    img.src = url
  }

  const uploadAvatarEdit = async (clientId, file) => {
    console.log('Uploading avatar for client id:', clientId)
    try {
      setUploadingAvatarEdit(true)
      const form = new FormData()
      form.append('avatar', file)
      await axios.post(`${urlValue}/studio/avatar`, form, {
        headers: {
          'access-token': unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token,
          'X-CSRF-Token': unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken,
          'client-id': clientId,
          'folder': 'clients'
        },
        withCredentials: true,
      })
      openAlert('#alert-ac', () => { setAlert({ title: t('alerts.avatarUploadSuccess'), visible: true }) }, 4000,
        () => { setAlert({ ...alert, visible: false }) });
    } catch (e) {
      const serverMessage = e?.response?.data?.message || e?.message || t('alerts.avatarUploadError')
      console.error('Avatar upload error', e)
      openAlert('#alert-ac', () => { setAlert({ title: serverMessage, visible: true, error: true }) }, 5000,
        () => { setAlert({ ...alert, visible: false }) });
    } finally {
      setUploadingAvatarEdit(false)
      setAvatarFileEdit(null)
    }
  }

  const selectAll = (e) => {
    const checked = e.target.checked;
    setAllSelected(checked);
    if (checked) {
      setUsersDelete(filteredClients);
      document.querySelectorAll("#users-all tbody input[type='checkbox']").forEach((item) => {
        item.checked = true;
      });
    } else {
      setUsersDelete([]);
      document.querySelectorAll("#users-all tbody input[type='checkbox']").forEach((item) => {
        item.checked = false;
      });
    }
  }

  const deleteMultiple = async () => {
    try {
      if (usersDelete.length > 0) {
        setLoading(true)
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        
        for (let i = 0; i < usersDelete.length; i++) {
          const resp = await axios({
            method: 'get',
            url: `${urlValue}/studio/client-project`,
            headers: { 'access-token': token, },
          })
          const id = resp?.data.filter(value => {
            if (
              value.project_id === selectedProject.id &&
              value.client_id === usersDelete[i].id
            ) {
              return value
            }
          })[0]?.id
          
          try {
            await axios({
              method: 'delete',
              url: `${urlValue}/studio/client-project/${id}`,
              headers: {
                'access-token': token,
                'X-CSRF-Token': csrfToken
              },
              withCredentials: true,
            })
          }
          catch (error) {
            console.log("Error a eliminar el id: " + id, error)
          }
        }
      }
    } catch (error) {
      setLoading(false)
      console.log("Error a eliminar multiples", error)
      // setModalDelete(false)
    } finally {
      closeModalVw("#deletemany-md", () => setIsModalOpen({ ...isModalOpen, delete_many: false }))
      // setModalDelete(false)
      window.location.reload();
    }
  }

  const selectForDelete = (e, item) => {
    if (e.target.checked) {
      setUsersDelete([...usersDelete, item]);
    } else {
      setAllSelected(false);
      setUsersDelete(usersDelete.filter(x => x.id !== item.id));
    }
  }

 

  const [selectedRadio, setSelectedRadio] = useState('TP');
  function getSelectedRadioValue(e) {
 
    if (selectedRadio === 'TP') {
      openModalVw("#adduser-md", () => setIsModalOpen({ ...isModalOpen, new: true }))
    }
    else if (selectedRadio === 'Studio') {
      openModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpenUserStudio, new: true }))
    }
  }

  const columns = [
    {
      header: (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <input
            type="checkbox"
            id="select-all-clients"
            checked={allSelected}
            onChange={selectAll}
            style={{ cursor: 'pointer', width: 14, height: 14, accentColor: '#0038A8' }}
          />
          <span>{t('common.ntUser')}</span>
        </div>
      ),
      field: 'ccms_name',
      width: '50%',
      render: (value, client) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CheckBox2
            onChange={(e) => selectForDelete(e, client)}
            default={false}
            id={`${client.ccms_id}`}
            text=""
          />
          <div style={{ marginLeft: 5, fontSize: 12 }}>{value}</div>
        </div>
      )
    },
    {
      header: t('common.bms'),
      field: 'ccms_id',
      width: '30%',
      align: 'left',
      render: (value) => <div style={{fontSize: 12}}>{value}</div>
    },
    {
      header: t('common.actions'),
      field: 'actions',
      width: '20%',
      align: 'center',
      render: (_, client) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
          <img
            src="/icons/edit.png"
            alt="edit"
            style={{ width: 15, cursor: 'pointer' }}
            onClick={() => openModal('edit', client)}
          />
          <img
            src="/icons/trash.png"
            alt="trash"
            style={{ width: 15, cursor: 'pointer' }}
            onClick={() => openModal('delete', client)}
          />
        </div>
      )
    }
  ];
  
  const filteredClients = clients.filter(client => {
    if (search === '') {
      return true;
    } else if (
      client?.ccms_id?.toLowerCase()?.includes(search.toLowerCase()) ||
      client?.ccms_name?.toLowerCase()?.includes(search.toLowerCase())
    ) {
      return true;
    }
    return false;
  });

  useEffect(() => {
    setAllSelected(false);
    setUsersDelete([]);
  }, [search]);

  return (
    <>
      <section className="container-settings general-container" id="container">
        {isGenAI ? <SideBarGenAI active={'Clients'} /> : <SideBar active={'Clients'} />}
        <div className="container">
          <div className="con_title_bar">
            <TitleBar />
          </div>
          <div className="container-info w-100 d-flex flex-row flex-wrap justify-space-between">
            <div className="d-flex flex-row align-items-center flex-wrap justify-space-between w-100">
              <div className="title d-flex flex-row align-items-center ml-2" style={{ whiteSpace: "nowrap" }}>
                <div>
                  <h2>{selectedProject.name}</h2>
                </div>
                <div className="p-1 separator">-</div>
                <div>
                  <h1>{t('menu.projectUsers')}</h1>
                  {/* <button type='button' className="btn btn-primary" }>Registrar</button> */}
                </div>
              </div>
            </div>

            <div className="body pt-1 pb-3 account-container account-c w-100" style={{ backgroundColor: '#F9F9F9', borderRadius: 25 }}>
              <h2 className="pl-3" style={{ color: '#0B5FA3', fontSize: 18, marginBottom: 15 }}>{t('menu.accountManagement')} - Client</h2>

              <div className="pl-3 d-flex flex-row align-items-center justify-space-between">
                <div className=" head w-100 ">

                  <div className=" home-search bg-white d-flex flex-row align-items-center justify-space-between"
                    style={{ borderRadius: 20, backgroundColor: 'white', width: 215, border: '1px solid gray' }}>
                    <input
                      type="text"
                      placeholder={t('common.search')}
                      onChange={event => {
                        setSearch(event.target.value)
                      }}
                      style={{ border: 'none', marginLeft: 7, maxWidth: 160, borderRadius: '20px' }}
                      className="p-2 home-search"
                    />
                    <div className="p-1 pr-4 mt-1">
                      <img src="/icons/search.svg" style={{ width: 16 }} alt="magnifying" />
                    </div>
                  </div>    

                  <div className="flex flex-1 items-center  jsutify-end">
                    <div id="adduser-btn" className="ml-2 btn-top btn-top-new newProject" onClick={() => openModalVw("#typeuser-md", () => setIsModalOpenTypeUser({ ...isModalOpenTypeUser, new: true }))} style={{ backgroundColor: '#0038A8' }}>
                      <span className='' style={{ color: 'white !important' }}>{t('menu.addUser')}</span>

                      <Tooltip anchorSelect="#adduser-btn" content={t('menu.projectUserTooltip')} place="top" />
                    </div>
                    <div onClick={() => openModalVw("#deletemany-md", () => setIsModalOpen({ ...isModalOpen, delete_many: true }))} 
                      style={{backgroundColor: 'rgb(223, 130, 9) !important'}}
                      className="ml-2 btn-top btn-top-delete newProject">
                      <span className='' style={{ color: 'white !important' }}>{t('common.delete')}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className='pl-2'>
                <DataTable
                  columns={columns}
                  data={filteredClients}
                  tableRef={ref}
                  tableId="users-all"
                  keyField="id"
                  emptyMessage={t('menu.usersNotFound')}
                  tableStyles={{ 
                    borderRadius: '8px',
                    overflow: 'hidden',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                  }}
                  headerStyles={{
                    backgroundColor: '#f5f5f5',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}
                  rowStyles={{
                    transition: 'background-color 0.2s'
                  }}
                />
              </div>
            </div>

            <ProjectAdministrators refresh = {refreshAdmin} />

          </div>
          {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error} />}
        </div>
      </section>

      {/* Eliminar usuarios de client */}
      {isModalOpen.delete &&
        <ModalVw id="deleteuser-md" visible={isModalOpen.delete}  >
          <ModalContent clases={` sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#deleteuser-md", () => setIsModalOpen({ ...isModalOpen, delete: false }))} />
            <ModalBody clases={``} >


              {/* <Modal isOpen={isModalOpen.delete} style={customModal} ariaHideApp={false}> */}
              <div id="container-modal" className='modal-c'>
                <img src="/icons/alert.png" alt="" />
                <h1>{t('menu.deleteUserModal')}</h1>
                <h1>{t('menu.deleteConfirmQuestion')}</h1>
                <div className="buttons-modal">
                  <button
                    onClick={() => closeModalVw("#deleteuser-md", () => setIsModalOpen({ ...isModalOpen, delete: false }))}
                    className="cancel btn-modal-cancel"
                  >
                    {t('common.cancel')}
                  </button>
                  <button onClick={onSubmitDelete} className="accept">
                    {t('common.yes')}
                  </button>
                </div>
              </div>
              {/* </Modal> */}

            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {/* Eliminar varios usuarios de client */}
      {isModalOpen.delete_many &&
        <ModalVw id="deletemany-md" visible={isModalOpen.delete_many}  >
          <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#deletemany-md", () => setIsModalOpen({ ...isModalOpen, delete_many: false }))} />
            <ModalBody clases={``} >


              {/* <Modal isOpen={isModalOpen.delete} style={customModal} ariaHideApp={false}> */}
              <div id="container-modal" className='modal-c'>
                <img src="/icons/alert.png" alt="" />
                <h1>{t('menu.deleteManyUserModal')}</h1>
                <h1>{t('menu.deleteConfirmQuestion')}</h1>
                <div className="buttons-modal">
                  <button
                    onClick={() => closeModalVw("#deletemany-md", () => setIsModalOpen({ ...isModalOpen, delete_many: false }))}
                    className="cancel btn-modal-cancel"
                  >
                    {t('common.cancel')}
                  </button>
                  <button type='button' onClick={() => deleteMultiple()} className="accept">
                    {t('common.yes')}
                  </button>
                </div>
              </div>
              {/* </Modal> */}

            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {/* Abrir modal de cual tipo de usuarios agregar */}
      {isModalOpenTypeUser.new &&
        <ModalVw id="typeuser-md" visible={isModalOpen.new} className="z-[50]" >
          <ModalContent clases={`w-auto  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#typeuser-md", () => setIsModalOpenTypeUser({ ...isModalOpenTypeUser, new: false }))} />
            <ModalBody clases={``} >
              <div id="container-modal" className="addUser-modal bg-[#FAFAFA]">
                <h2 className='text-[#1C6FB0]'>{t('menu.chooseTypeUser')}</h2>
                <div id='form-type'  >
                  <div className="inputs-modal">
                    <div className="  flex flex-row items-center">
                      <input
                        name="typeu"
                        type="radio"
                        id="typeuser-1"
                        onChange={(e) => setSelectedRadio("Studio")}
                      />
                      <label htmlFor='typeuser-1' className="text-[#2E2E2E] font-bold ml-3">{t('menu.userStudio')}</label>
                    </div>
                    <div className="  flex flex-row items-center">

                      <input
                        name="typeu"
                        type="radio"
                        id="typeuser-1"
                        onChange={(e) => setSelectedRadio("TP")}
                      />
                      <label htmlFor='typeuser-1' className="text-[#2E2E2E] font-bold ml-3">{t('menu.userClient')}</label>
                    </div>
                  </div>

                  <div className="buttons-modal">
                    <button
                      onClick={() => closeModalVw("#typeuser-md", () => setIsModalOpenTypeUser({ ...isModalOpenTypeUser, new: false }))}
                      type="button"
                      className="cancel btn-bottom btn-bottom-cancel"
                    >
                      {t('common.cancel')}
                    </button>
                    <div className="accept btn-bottom btn-bottom-create"
                      type="button"
                      onClick={(e) => { getSelectedRadioValue(e) }}
                    >
                      {t('common.select')}
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {/* Agregar usuarios de Studio */}
      {isModalOpenUserStudio.new &&
        <ModalVw id="adduser-studio" visible={isModalOpenUserStudio.new} className="z-[500]">
          <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpen, new: false }))} />
            <ModalBody clases={``} >
                <NewUserStudio isModalOpen={isModalOpenUserStudio} 
                  closeModal={() => { closeModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpen, new: false }))} }
                  closeFunction={() => { 
                    setIsModalOpenUserStudio({ ...isModalOpenUserStudio, new: false })
                    setIsModalOpenTypeUser({ ...isModalOpenTypeUser, new: false })
                    setRefreshAdmin(!refreshAdmin)
                  }}
                  associateToProject={true}
                  project_id={selectedProject.id}
                />
            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {/* Agregar usuarios de client */}
      {isModalOpen.new &&
        <ModalVw id="adduser-md" visible={isModalOpen.new} className="z-[500]" style={{maxWidth: 1100, margin: 'auto'}}>
          <ModalContent clases={`w-100  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#adduser-md", () => setIsModalOpen({ ...isModalOpen, new: false }))} />
            <ModalBody clases={``} >
              <NewUserClient isModalOpen={isModalOpenUserStudio} 
                closeModal={() => { closeModalVw("#adduser-md", () => setIsModalOpen({ ...isModalOpen, new: false })) } }
                selectedProject = {selectedProject}
                closeFunction={() => { 
                  setIsModalOpen({ ...isModalOpen, new: false })
                  setIsModalOpenTypeUser({ ...isModalOpenTypeUser, new: false })
                  setRefresh(!refresh)
                }}
                associateToProject={true}
                project_id={selectedProject.id}
              />
            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {/* Editar usuarios de client */}
      {isModalOpen.edit &&
        <ModalVw id="edituser-md" visible={isModalOpen.edit}  >
          <ModalContent clases={`bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#edituser-md", () => setIsModalOpen({ ...isModalOpen, edit: false }))} />
            <ModalBody clases={``} >
              {/* <Modal isOpen={isModalOpen.edit} style={customModal} ariaHideApp={false}> */}
              <div id="container-modal" className="addUser-modal">
                <h2>{t('menu.editUserClient')} </h2>
                <form onSubmit={handleSubmit(onSubmitEdit)}>
                  <div className="inputs-modal">
                    <div className="input">
                      <span>{t('common.bms')}:</span>
                      <input
                        placeholder={t('menu.specificUserId')}
                        {...register('id', { required: true, pattern: /^\d+$/ })}
                        type="text"
                        disabled={true}
                      />
                    </div>
                    <div className="input">
                      <span>{t('common.ntUser')}:</span>
                      <input placeholder={t('menu.enterCCMS')} 
                        {...register('name', { required: true })} type="text" />
                    </div>
                    <div className="input">
                      <span>{t('common.wave')}:</span>
                      <input id="wave-edit" placeholder={t('menu.selectUserWave')}
                        {...register('wave', { required: true })} type="text" />
                    </div>
                    <div className="input">
                      <span>{t('common.maxChat')}:</span>
                      <input type='number' id="ccms_name" placeholder={t('menu.enterMaxChat')} 
                        {...register('max_multichat', { required: true })} />
                    </div>
                    <div className='input'>
                      <span>{t('menu.genderAvatar')}:</span>

                      <select id="gender_avatar" className='select-nesting' {...register('gender_avatar', { required: false })}
                        style={{
                          padding: '2px 18px 2px 10px',
                          backgroundColor: 'white', border: '1px solid #0087FF',
                          borderRadius: 10, appearance: 'none', fontSize: 14
                        }}>
                        <option disabled selected>{t('common.select')}</option>
                        <option value="male">{t('common.male')}</option>
                        <option value="female">{t('common.female')}</option>
                        <option value="other">{t('common.other')}</option>
                      </select>
                    </div>
                  </div>
                  <div className="input" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
                    <div style={{ width: 50, height: 50, border: '1px solid #ddd', borderRadius: 6, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
                      {avatarPreviewEdit ? <img src={avatarPreviewEdit} alt="avatar" style={{ maxWidth: '100%', maxHeight: '100%', filter: 'none' }} /> : <img src="/avatar.png" alt="avatar" style={{ width: 40, filter: 'none' }} />}
                    </div>
                    <div>
                      <input type="file" accept="image/png,image/jpeg" onChange={handleAvatarEditChange} />
                    </div>
                  </div>
                  <div className="buttons-modal">
                    <button
                      onClick={() => setIsModalOpen({ ...isModalOpen, edit: false })}
                      type="button"
                      className="cancel btn-bottom btn-bottom-cancel"
                    >
                      {t('common.cancel')}
                    </button>
                    <button className="btn-bottom btn-bottom-create accept" type="submit">
                      {t('common.confirm')}
                    </button>
                  </div>
                </form>
              </div>
              {/* </Modal> */}
            </ModalBody>
          </ModalContent>
        </ModalVw>}
    </>
  )
}
